export function generateUniqueName(name: string, existingNames: string[]): string {
    // todomz improve with rubibot
    if (existingNames.includes(name)) {
        //name collides with an existing name
        let number = 0; //init counter
        let regex = /(?=(\(\d+\)$))/; //the regex for "name(number)"
        let isNumbered = name.match(regex); //match returns matches, last one is the one we need. if not found, null is returned.
        if (isNumbered !== null) {
            name = name.replace(isNumbered[isNumbered.length - 1], ''); //found suffix of "(number)" - remove it.
        }
        let originalName = name;
        while (existingNames.includes(name)) {
            name = originalName + '(' + ++number + ')'; //find an available enumeration
        }
    }
    return name;
}
